module.exports = __webpack_public_path__ + "img/scene5.240652a4.png";